import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { Project } from "@/models/project.model"
import { ODataQueryBuilder } from "@/builder/odata-query-builder"
import { BaseModel } from "@/models/base.model"
import { type IBase } from "@/interfaces/api/base.interface"
import { BaseRepository } from "@/repositories/base-repository"
import { type ModelConstructorSignature } from "@/models/types/model-constructor-signature"
import { type IStoreFunctionsConfig } from "@/store/base-functions/base-store-functions"

export abstract class AbstractProjectAdministrativeItemController<
  Model extends BaseModel,
  IData extends IBase,
  Repository extends BaseRepository<IData>
> extends GenericModelController<Model, IData, Repository> {
  protected retrievedForProjects: Set<string> = new Set()

  protected constructor(
    modelType: ModelConstructorSignature<IData, Model>,
    storeFunctionsConfig: IStoreFunctionsConfig<Model>,
    repository: Repository
  ) {
    super(modelType, storeFunctionsConfig, repository)
  }

  public async getListForProject(project: Project): Promise<void> {
    if (this.retrievedForProjects.has(project.id!)) {
      return
    }
    this.retrievedForProjects.add(project.id!)

    const query = new ODataQueryBuilder().eq("project_id", project.id!)
    await this.getList({ query })
  }
}
